"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunnelAndStatus = void 0;
var react_1 = __importStar(require("react"));
var SingleMetricStacked_1 = __importDefault(require("@CommonFrontend/Charts/BarChart/SingleMetricStacked"));
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var BarTickTwoLine_1 = __importDefault(require("@CommonFrontend/Charts/Customise/BarTickTwoLine"));
var BarLabelCircle_1 = __importDefault(require("@CommonFrontend/Charts/Customise/BarLabelCircle"));
var BarShapeWave_1 = __importDefault(require("@CommonFrontend/Charts/Customise/BarShapeWave"));
var BarTooltipPageCountBottom_1 = __importDefault(require("@CommonFrontend/Charts/Customise/BarTooltipPageCountBottom"));
var BarTooltipPageCountTop_1 = __importDefault(require("@CommonFrontend/Charts/Customise/BarTooltipPageCountTop"));
var BarTooltipPageValueBottom_1 = __importDefault(require("@CommonFrontend/Charts/Customise/BarTooltipPageValueBottom"));
var BarTooltipPageValueTop_1 = __importDefault(require("@CommonFrontend/Charts/Customise/BarTooltipPageValueTop"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var Types_2 = require("Reports/Types");
var SafeDivide_1 = require("@CommonFrontendBackend/Utils/SafeDivide");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var c = (0, BemBuilder_1.default)("funnel-and-status");
var TOOLTIP_MAPPING = (_a = {},
    _a[Types_2.AnalyticsPageMetric.PageCount] = { top: BarTooltipPageCountTop_1.default, bottom: BarTooltipPageCountBottom_1.default },
    _a[Types_2.AnalyticsPageMetric.PageValue] = { top: BarTooltipPageValueTop_1.default, bottom: BarTooltipPageValueBottom_1.default },
    _a);
var getTooltipComponent = function (Component, opts) { return function (props) { return react_1.default.createElement(Component, __assign({ opts: opts }, props)); }; };
var getTickDisplayValueFormatter = function (pageMetric, currency) {
    if (pageMetric !== Types_2.AnalyticsPageMetric.PageValue) {
        return undefined;
    }
    return function (data) {
        var value = data.data.reduce(function (acc, next) { return acc + next; }, 0);
        var decimalPrecision = value >= 1000 ? 1 : 0;
        return {
            title: data.xAxisName,
            subtitle: (0, FormatCurrency_1.formatAbbreviatedCurrency)(value, currency, decimalPrecision, true),
        };
    };
};
var pageMetricOptions = [
    {
        label: "Page count",
        value: Types_2.AnalyticsPageMetric.PageCount,
    },
    {
        label: "Page value",
        value: Types_2.AnalyticsPageMetric.PageValue,
    },
];
var pageMetricTelemetryMap = Object.freeze({
    Count: "pipeline_chart_select_count",
    Value: "pipeline_chart_select_value",
});
var FunnelAndStatus = function (_a) {
    var _b, _c;
    var pageStatusMetrics = _a.pageStatusMetrics, pageVelocity = _a.pageVelocity, selectedCurrency = _a.selectedCurrency, firePipelineTelemetry = _a.firePipelineTelemetry;
    var _d = __read((0, react_1.useState)(Types_2.AnalyticsPageMetric.PageCount), 2), pageMetric = _d[0], setPageMetric = _d[1];
    var tooltipOpts = {
        currency: selectedCurrency,
        avgDays: { draft: 12, live: 5, accepted: 14, declined: 25 },
        avgPageValue: toTooltipPageValue(pageStatusMetrics),
    };
    function onPageMetricChange(optionValue) {
        if (optionValue === pageMetric)
            return;
        setPageMetric(optionValue);
        firePipelineTelemetry(pageMetricTelemetryMap[optionValue]);
    }
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement(kaleidoscope_1.Tabs, null,
            react_1.default.createElement(kaleidoscope_1.TabList, { "aria-label": "Funnel or Status selector" },
                react_1.default.createElement(kaleidoscope_1.Tab, { onClick: function () {
                        firePipelineTelemetry("pipeline_chart_select_funnel");
                    } }, "Funnel"),
                react_1.default.createElement(kaleidoscope_1.Tab, { onClick: function () {
                        firePipelineTelemetry("pipeline_chart_select_status");
                    } }, "Status")),
            react_1.default.createElement("div", null,
                react_1.default.createElement(kaleidoscope_1.SegmentedControl, { className: c("count-value-control"), label: "Page Metric", labelHidden: true, onClickHandler: onPageMetricChange, options: pageMetricOptions, selectedValue: pageMetric })),
            react_1.default.createElement(kaleidoscope_1.TabPanels, { className: c("tab-panels") },
                react_1.default.createElement(kaleidoscope_1.TabPanel, { className: c("tab-panel") },
                    react_1.default.createElement(FunnelChartContainer, { tickValueFormatter: getTickDisplayValueFormatter(pageMetric, selectedCurrency), chartData: toFunnelChartData(pageStatusMetrics, pageMetric), averageCreateCycle: (_b = pageVelocity === null || pageVelocity === void 0 ? void 0 : pageVelocity.pageCycleTimes) === null || _b === void 0 ? void 0 : _b.averageCreate, averageCloseCycle: (_c = pageVelocity === null || pageVelocity === void 0 ? void 0 : pageVelocity.pageCycleTimes) === null || _c === void 0 ? void 0 : _c.averageClose })),
                react_1.default.createElement(kaleidoscope_1.TabPanel, { className: c("tab-panel") },
                    react_1.default.createElement(SingleMetricStacked_1.default, { data: toStatusChartData(pageStatusMetrics, pageMetric), customisations: {
                            tick: {
                                height: 60,
                                component: BarTickTwoLine_1.default,
                                formatter: getTickDisplayValueFormatter(pageMetric, selectedCurrency),
                            },
                            shape: { bottom: BarShapeWave_1.default },
                            tooltip: {
                                bottom: getTooltipComponent(TOOLTIP_MAPPING[pageMetric].bottom, tooltipOpts),
                                top: getTooltipComponent(TOOLTIP_MAPPING[pageMetric].top, tooltipOpts),
                            },
                        } }))))));
};
exports.FunnelAndStatus = FunnelAndStatus;
var FunnelChartContainer = function (_a) {
    var tickValueFormatter = _a.tickValueFormatter, chartData = _a.chartData, averageCreateCycle = _a.averageCreateCycle, averageCloseCycle = _a.averageCloseCycle;
    return (react_1.default.createElement("div", { className: c("funnel-panel-container") },
        react_1.default.createElement("div", { className: c("funnel-chart") },
            react_1.default.createElement(SingleMetricStacked_1.default, { data: chartData, customisations: {
                    tick: {
                        height: 60,
                        component: BarTickTwoLine_1.default,
                        formatter: tickValueFormatter,
                    },
                    label: BarLabelCircle_1.default,
                } })),
        react_1.default.createElement("div", { className: c("funnel-timeline") },
            [averageCreateCycle, averageCloseCycle].map(function (timeMetric, index) { return (react_1.default.createElement(react_1.default.Fragment, { key: "".concat(timeMetric, "_").concat(index) },
                react_1.default.createElement("div", { className: c("timeline-circle") }),
                react_1.default.createElement("div", { className: c("timeline-line") }),
                react_1.default.createElement("div", { className: c("timeline-days-label") },
                    react_1.default.createElement(icons_1.Clock, { className: c("timeline-clock") }),
                    react_1.default.createElement(kaleidoscope_1.Label, { size: "l" },
                        timeMetric || 0,
                        " days")),
                react_1.default.createElement("div", { className: c("timeline-line") }))); }),
            react_1.default.createElement("div", { className: c("timeline-circle") }))));
};
var statusChartConfig = Object.freeze([
    { xAxisName: "Draft", color: tokens_1.palette.grey700 },
    { xAxisName: "Live", color: tokens_1.palette.orange300 },
    { xAxisName: "Accepted", color: tokens_1.palette.green300 },
    { xAxisName: "Declined", color: tokens_1.palette.red300 },
]);
function toTooltipPageValue(pageStatusMetrics) {
    if (!pageStatusMetrics)
        return undefined;
    return ["draft", "live", "accepted", "declined"].reduce(function (pageValues, nextStatus) {
        pageValues[nextStatus] = {
            total: (0, SafeDivide_1.safeDivide)(pageStatusMetrics[nextStatus].totalValue, pageStatusMetrics[nextStatus].totalCount),
            period: (0, SafeDivide_1.safeDivide)(pageStatusMetrics[nextStatus].periodValue, pageStatusMetrics[nextStatus].periodCount),
        };
        return pageValues;
    }, {});
}
function toStatusChartData(pageStatusMetrics, pageMetric) {
    if (!pageStatusMetrics) {
        return [{ xAxisName: "...", data: [] }];
    }
    return statusChartConfig.map(function (_a) {
        var xAxisName = _a.xAxisName, color = _a.color;
        var statusName = xAxisName.toLowerCase();
        var pageStatusResult = pageStatusMetrics[statusName];
        var isClosedStatus = [Types_1.ProjectStatus.Accepted, Types_1.ProjectStatus.Declined].includes(xAxisName.toLowerCase());
        var barTopValue = pageStatusResult["period".concat(pageMetric)];
        var barBottomValue = isClosedStatus
            ? 0
            : pageStatusResult["total".concat(pageMetric)] - pageStatusResult["period".concat(pageMetric)];
        var data = [barTopValue, barBottomValue];
        return { color: color, xAxisName: xAxisName, data: data };
    });
}
function toFunnelChartData(pageStatusMetrics, pageMetric) {
    if (!pageStatusMetrics) {
        return [{ xAxisName: "...", data: [] }];
    }
    var draft = pageStatusMetrics.draft, live = pageStatusMetrics.live, accepted = pageStatusMetrics.accepted, declined = pageStatusMetrics.declined;
    var acceptedMetric = accepted["period".concat(pageMetric)];
    var declinedMetric = declined["period".concat(pageMetric)];
    var liveAndClosedMetric = live["total".concat(pageMetric)] + acceptedMetric + declinedMetric;
    var allPagesMetric = draft["total".concat(pageMetric)] + liveAndClosedMetric;
    return [
        {
            xAxisName: "All Pages",
            data: [allPagesMetric],
        },
        {
            xAxisName: "Live",
            data: [liveAndClosedMetric],
            label: allPagesMetric > 0 ? "".concat(Math.trunc((liveAndClosedMetric / allPagesMetric) * 100), "%") : undefined,
        },
        {
            xAxisName: "Closed",
            data: [acceptedMetric, declinedMetric],
            label: liveAndClosedMetric > 0
                ? "".concat(Math.trunc(((acceptedMetric + declinedMetric) / liveAndClosedMetric) * 100), "%")
                : undefined,
        },
    ];
}
